const validateUrl = (url) => {
  if (!url) {
    return false;
  }

  if (url.length < 3) {
    return false
  }

  try {
    new URL(url)
  } catch (e) {
    return false;
  }

  return true
}

export default validateUrl
